export default __webpack_public_path__ + "static/article-financing-your-home-improvements-7cd027b8643a3f8e06e39dd2830a55f7.jpg";